import { Helmet } from 'react-helmet'
import React from 'react'
import RestaurantsPageLayout from '../../../components/restaurants/RestaurantsPageLayout'
import ChatDashboard from './components/ChatDashboard'

const Messages: React.FC = () => {
  return (
    <>
      <Helmet><title>Resactly | Messages</title></Helmet>
      <RestaurantsPageLayout title={'Messages'} body={<ChatDashboard />} />
    </>
  )
}

export default Messages
